import "./ButtonBuyTickets.scss";
const ButtonBuyTickets = () => {
  return (
    <button
      className="btn-buy-tickets"
      onClick={() =>
        window.open("https://shop.zixxar.net/platform-shop?category=Tickets")
      }
    >
      <span className="font-pnr font-size-16">Buy tickets</span>
    </button>
  );
};
export default ButtonBuyTickets;
